import React from 'react';

import { LayoutPageHeading } from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { useLocale } from 'src/modules/locale';
import { ProductEntity } from 'src/modules/products';

import { ProductLocalizedEntity } from 'src/modules/products';
import ProductsDownloads from 'src/modules/products/components/downloads/ProductsDownloads';
import ProfessionalsDownloadsProductsSearchIndex from 'src/modules/professionals/downloads/products/components/search/index/ProfessionalsDownloadsProductsSearchIndex';

type ProfessionalsDownloadsProductsPageDetailProps = {
  page: ProductEntity;
};

const ProfessionalsDownloadsProductsPageDetail: React.FunctionComponent<ProfessionalsDownloadsProductsPageDetailProps> = (
  props
) => {
  const { page } = props;
  const { intl, getLocalizedObject } = useLocale();
  const product = getLocalizedObject<ProductLocalizedEntity>(page);

  if (!product?.name) return null;

  const pageProperties = {
    title: intl.formatMessage(
      { id: 'page/professionals/downloads/products/detail/head/page_title' },
      { name: product?.name }
    ),
    description: intl.formatMessage(
      { id: 'page/professionals/downloads/products/detail/head/meta_description' },
      { name: product?.name }
    ),
  };

  return (
    <LayoutPage
      {...pageProperties}
      breadcrumbs={[
        {
          title: intl.formatMessage({ id: 'breadcrumbs/professionals' }),
          href: '/professionals',
        },
        {
          title: intl.formatMessage({ id: 'breadcrumbs/professionals/downloads' }),
          href: '/professionals/downloads',
        },
        {
          title: intl.formatMessage({ id: 'breadcrumbs/professionals/downloads/product_data' }),
          href: '/professionals/downloads/products',
        },
        { title: product.name },
      ]}>
      <LayoutPageHeading
        title={intl.formatMessage(
          { id: 'page/professionals/downloads/products/detail/title' },
          { name: product?.name }
        )}
      />

      <ProfessionalsDownloadsProductsSearchIndex useFilters={false} redirect={true} />

      <section>
        <ProductsDownloads product={page} />
      </section>
    </LayoutPage>
  );
};

export default ProfessionalsDownloadsProductsPageDetail;
